import axios from 'axios'
import {Notify} from 'vant'
import {isEmpty, getLocalValue} from '../utils/commonUtil'
import Vue from 'vue'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'

import {
authLogin,



} from '@/service/auth/loginService'
Vue.use(ConfirmPlugin)
Vue.use(Notify)

const http = axios.create({

baseURL: '',
headers: {
'Content-Type': 'application/json',
},
timeout: 30 * 1000,


})


const requestBefore = async (request) => {
if(isEmpty(getLocalValue('token')) || new Date().getTime() >= getLocalValue('expires')) {
await authLogin()
}
request.headers.common.Authorization = 'Bearer ' + getLocalValue('token')

if(!isEmpty(getLocalValue('MSCRMCallerID'))) {
request.headers.common.MSCRMCallerID = getLocalValue('MSCRMCallerID')
}

let urlList = request.url.split('/')
let apiList = ['hd_metadata', 'hd_list', 'hd_view', 'hd_add', 'hd_update', 'hd_delete', 'hd_form', 'hd_count']
if(apiList.includes(urlList[urlList.length - 1])) {
request.data.clientid = getLocalValue('userId')
}
return request
}


const requestError = (error) => {
return Promise.reject(error)
}




const responseAfter = response => {
return response
}

/*

const codeMessage = {
200: '服务器成功返回请求的数据。',
201: '新建或修改数据成功。',
202: '一个请求已经进入后台排队（异步任务）。',
204: '删除数据成功。',
400: '发出的请求有错误，服务器没有进行新建或修改数据的操作。',
401: '用户没有权限（令牌、用户名、密码错误）。',
403: '用户得到授权，但是访问是被禁止的。',
404: '发出的请求针对的是不存在的记录，服务器没有进行操作。',
406: '请求的格式不可得。',
410: '请求的资源被永久删除，且不会再得到的。',
422: '当创建一个对象时，发生一个验证错误。',
500: '服务器发生错误，请检查服务器。',
502: '网关错误。',
503: '服务不可用，服务器暂时过载或维护。',
504: '网关超时。',
}
*/

const checkStatus = (response) => {
if(response.status >= 400) {
console.log('网络状态', response.status)







/*
const errorMessage = codeMessage[response.status] || response.statusText

console.error(`请求错误 ${response.status}: ${errorMessage}`)
if(response.status === 401) {









let url = `${getLoginUrl()}/login/${process.env.LOGIN_URL_ID}/oauth2/token`
let formData = new FormData()
formData.append('client_id', process.env.CRM_Client_ID)
formData.append('client_secret', process.env.CLIENT_SECRET)
formData.append('resource', process.env.RESOURCE)
formData.append('grant_type', process.env.GRANT_TYPE)
let headerconfig = {
headers: {
'Content-Type': 'application/x-www-form-urlencoded',
},
timeout: 20000,
}
axios.post(url, formData, headerconfig).then(function (res) {
console.log('&&&&&&&&&&&&&&', res.data.access_token)
setLocalValue('token', res.data.access_token)





let url = response.config.url
let config = {
headers: {
'Content-Type': 'application/json',
'Authorization': 'Bearer ' + res.data.access_token,
},
timeout: 20000,
}
var str = response.config.data.toString()
var userId = getLocalValue('userId').toString()
var strjson = str.substring(0, str.length) + ', "clientid":"' + userId + '"}'
return axios.post(url, JSON.parse(strjson), config)
})
}
*/
}
}

http.interceptors.request.use(requestBefore, requestError)
http.interceptors.response.use(responseAfter, (err) => {



















if(err && err.response) {
checkStatus(err.response)
}
let config = err.config

if(!config || !config.retry) return Promise.reject(err)


config.__retryCount = config.__retryCount || 0


if(config.__retryCount >= config.retry) {

return Promise.reject(err)
}


config.__retryCount += 1


let backOff = new Promise((resolve) => {
setTimeout(() => { resolve() }, config.retryDelay || 1)
})


return backOff.then(() => http.request(config))
})





























export default http



// WEBPACK FOOTER //
// ./src/utils/http.js